import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/auth/authentication.service';
import { Role } from '../models/role';
import { Observable } from 'rxjs';

export const authGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot,
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
	const router = inject(Router);
	const authenticationService = inject(AuthenticationService);

	const user = authenticationService.userValue;

	if (!user) {
		// Not logged in - redirect to login page
		return router.createUrlTree(['/login'], {
			queryParams: { returnUrl: state.url },
		});
	}

	// Redirect ADMIN and TM users away from this route
	if (user.role === Role.ADMIN) {
		return router.createUrlTree(['/dashboard']);
	}

	if (user.role === Role.TM && user.townId) {
		return router.createUrlTree(['/dashboard/towns', user.townId.toString()]);
	}

	// Check route role restrictions
	if (route.data['roles'] && !route.data['roles'].includes(user.role)) {
		// Role not authorized
		return false;
	}

	// Check token expiration
	const now = Date.now();
	if (user.expiresAt < now) {
		// Token expired - attempt refresh (returns Promise<boolean>)
		return authenticationService.refresh().then((refreshSuccessful) => {
			if (refreshSuccessful) {
				// Refresh succeeded, allow route activation
				return true;
			} else {
				// Refresh failed - redirect to login
				return router.createUrlTree(['/login'], {
					queryParams: { returnUrl: state.url },
				});
			}
		});
	}

	// Authorized - allow route activation
	return true;
};
